import { render, staticRenderFns } from "./AddGroupMember.vue?vue&type=template&id=11fbd04c"
import script from "./AddGroupMember.vue?vue&type=script&lang=js"
export * from "./AddGroupMember.vue?vue&type=script&lang=js"
import style0 from "./AddGroupMember.vue?vue&type=style&index=0&id=11fbd04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports